export { default as HistorialSalidas } from "./HistorialSalidas";

